var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_vm._v(" Training Videos ")])], 1), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "pb-3"
  }, [_vm._v(" Project Spectrum's train the trainer course offers an in depth step-by-step guide for navigating our platform and utilizing all the resources we offer. From registering as a new user all the way to completing a cyber readiness check, this video will help you understand what you need to succeed with Project Spectrum. ")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 pt-4"
  }, [_c('center', [_c('div', {
    staticStyle: {
      "position": "relative",
      "padding-top": "56.25%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "border": "5px outset #ddd",
      "position": "absolute",
      "top": "0",
      "left": "10%",
      "height": "75%",
      "width": "75%"
    },
    attrs: {
      "src": "https://customer-vqtiuw508mb7y2yt.cloudflarestream.com/3ac5685e37d928408f916ac55730ae0c/iframe?poster=https%3A%2F%2Fcustomer-vqtiuw508mb7y2yt.cloudflarestream.com%2F3ac5685e37d928408f916ac55730ae0c%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600",
      "allow": "accelerometer; gyroscope;  encrypted-media; picture-in-picture;",
      "allowfullscreen": "true"
    }
  })])])], 1)])])]), _c('b-modal', {
    ref: "my-modal",
    attrs: {
      "size": "lg",
      "hide-footer": "",
      "title": _vm.modalMessage
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v(" Please "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        query: {
          redirect: _vm.getRedirectRoute
        }
      }
    }
  }, [_c('a', [_vm._v("LOGIN")])]), _vm._v(" or "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_c('a', [_vm._v("SIGN UP")])]), _vm._v(" for project spectrum. ")], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }